import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { VendorService } from "../../../services/api/vendor.service";
import { VendorActions } from "../../actions/vendor.actions";
import { FailState } from "../../models/fail-state";
import { DailyStatsState } from "../../models/shared/daily-stats-state";

@Injectable()
export class VendorDailyStatsEffects {
	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(VendorActions.dailyStats.getApi),
			switchMap((action) =>
				this.vendorService.dailyStats(action.startDate, action.endDate).pipe(
					map((stats) => VendorActions.dailyStats.getSuccess({ stats, loading: false })),
					catchError((error) =>
						of(VendorActions.dailyStats.getFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private vendorService: VendorService
	) {}

	canUseStoreValue(state: DailyStatsState): boolean {
		return !_.has(state, "error") && !state.loading;
	}
}
